<!-- 制板费明细 -->
<template>
  <div class="price-details">
    <div 
      v-for="(data, type) in list" 
      :key="type" 
      :class="{ 'price-details__content':true, 'multicolumn': col > 1 }"
    >
      <p class="quote-container__right__title">
        {{ type === 'SMT' ? 'SMT费用明细' : 'PCB费用明细' }}
      </p>
      <ViewList
        :class="{ 'fpc-tips': isFpcNeedAudit && type === 'FPC' }"
        prefix="￥"
        :type="type"
        :emptyText="isFpcNeedAudit && type === 'FPC' ? `软硬结合板暂不支持自动计价\n具体价格以审核为准` : '还未有价格，请填写具体参数'"
        :col="col === 2 ? 1 : 2"
        :data="data"
      >
      <!-- PCB工程费 -->
        <template v-slot:gch="{ value }">
          <div class="price-details__content__value">
            {{ value }}
            <BaseTipPopover 
              width="'460px'" 
              placement="top"
              :content="`
                此优惠金额仅供参考，审核后满足以下条件可享此优惠工程费。\n
                1）无“阻抗”\n
                2）无“叠层结构”要求\n
                3）制版文件仅有一个PCB源文件或一个gerber文件，无生产工艺说明文档\n
                4）不包含订单备注\n
                5）不包含3.5mil及以下的线宽线距 \n
                6)  不包含:0.2mm及以下的最小孔径
              `" 
            >
              <span slot='reference' class="price-details__content__value__reference">减</span>
            </BaseTipPopover>
          </div>
        </template>
      </ViewList>
    </div>
  </div>
</template>

<script>
// 列表展示
import ViewList from '@@/components/viewList/index'
import { PRICE_FIELDS } from '@@/utils/constant'

export default {
  props: {
    type: {
      type: String,
      validator: function (value) {
        return ['PCB', 'FPC', 'SMT', 'PCB_SMT', 'FPC_SMT', 'SMT_PCB', 'SMT_FPC'].includes(value)
      }
    },
    pcbPrice: {
      type: Object,
      default: () => ({})
    },
    smtPrice: {
      type: Object,
      default: () => ({})
    },
    // 表面处理
    spray: {
      type: String,
      default: ''
    },
    isFpcNeedAudit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ViewList
  },
  computed: {
    col() {
      return this.type.split('_').length
    },
    list() {
      const { type, isFpcNeedAudit } = this
      const types = type.split('_')
      // PCB/FPC排前面
      return ['PCB', 'FPC', 'SMT']
        .filter(i => types.includes(i))
        .reduce((data, type) => {
          data[type] = isFpcNeedAudit && type === 'FPC' ? [] : this.getList(type)
          return data
        }, {})
    }
  },
  methods: {
    getList(type) {
      const { pcbPrice, smtPrice, spray } = this
      const data = type === 'SMT' ? smtPrice : pcbPrice
      let fields = PRICE_FIELDS[type]

      // PCBA订单的PCB费用字段
      if (this.type.includes('SMT') && ['PCB', 'FPC'].includes(type)) {
        fields = Object.assign(fields, {
          insurancefee: 'PCB品质服务费',
          invoicefee: '税费',
          expressage: '运费',
          discount_amount: '活动折扣',
        })
      }

      return Object.keys(fields)
        .filter(key => data[key] && data[key] > 0)
        .map(key => {
          let label = fields[key]
          if (key === 'sprayfee') {
            label = `${spray === 'OSP' ? 'OSP' : spray.substring(0, 2)}费`
          }
          let prefix
          // discount_amount - PCB活动折扣
          // activity_discount_fee - SMT活动折扣
          if (['activity_discount_fee', 'discount_amount'].includes(key)) {
            prefix = '-￥'
          }
          let slot
          // 显示减工程费 减 提示 (engineering_standard_file: 0-无减免 1-有减免 2-有订单备注导致无减免)
          if (key === 'gch' && data.engineering_standard_file === 1) {
            slot = 'gch'
          }
          // 特价板 工程费 改成 特价
          if (key === 'gch' && data.spec_discount === 1) {
            label = '特价'
          }
          return { label, value:  data[key], prefix, slot }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.price-details {
  display: flex;
  >div + div {
    margin-left: 6px;
  }
  .price-details__content {
    flex: 1;
    &.multicolumn {
      width: calc(50% - 3px);
      .view-list {
        min-height: calc(100% - 35px);
        background-color: $--background-base;
      }
    }
    .price-details__content__value {
      position: relative;
      .price-details__content__value__reference {
        position: absolute;
        top: -13px;
        right: -8px;
        color: #F65001;
      }
    }
  }
  .fpc-tips {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>